import { render, staticRenderFns } from "./RoundWinLose3.vue?vue&type=template&id=9dd32f0a&"
import script from "./RoundWinLose3.vue?vue&type=script&lang=js&"
export * from "./RoundWinLose3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports